var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex gap-4 align-items-center"},[_c('div',{staticClass:"indicator",class:{ 'in-range': _vm.inRange }}),_c('span',[_vm._v(_vm._s(_vm.inRange ? 'In range': 'Out of range'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }